<template>
  <div>
    <Header :title="$t('account.title')" />
    <div class="full-page-box" style="min-height: calc(100vh)">
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
import { Toast } from "vant";
export default {
  name: 'BillView',
  components: { Header},
  methods:{
    toshow(){
        Toast()
    }
  }
}
</script>

<style>

</style>
